(() => {
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const visibleImagesIn = (scope) => [...scope.querySelectorAll('.product__media img, .product-media-container img, .product__media-item img')]
    .map((image) => ({ image, rect: image.getBoundingClientRect() }))
    .filter(({ image, rect }) => !image.hidden && rect.width > 0 && rect.height > 0)
    .sort((a, b) => (b.rect.width * b.rect.height) - (a.rect.width * a.rect.height));

  const findProductImage = (source) => {
    const scope = source?.closest?.('product-info') || document;
    return visibleImagesIn(scope)[0]?.image || visibleImagesIn(document)[0]?.image;
  };

  const findCartIcon = () => {
    const cart = document.querySelector('#cart-icon-bubble');
    if (!cart) return null;
    const rect = cart.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? cart : null;
  };

  const pulseCartIcon = () => {
    const cart = findCartIcon();
    if (!cart || reducedMotion() || typeof cart.animate !== 'function') return;
    cart.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }],
      { duration: 220, easing: 'ease-out' }
    );
  };

  const flyToCart = (source) => {
    if (reducedMotion() || window.reselluneFlyToCartActive) return Promise.resolve();

    const image = findProductImage(source);
    const cart = findCartIcon();
    if (!image || !cart || typeof image.animate !== 'function') return Promise.resolve();

    const imageRect = image.getBoundingClientRect();
    const cartRect = cart.getBoundingClientRect();
    const sourceWidth = Math.min(130, Math.max(90, imageRect.width * .3));
    const sourceRatio = image.naturalWidth && image.naturalHeight
      ? image.naturalWidth / image.naturalHeight
      : imageRect.width / imageRect.height || 1;
    const sourceHeight = sourceWidth / sourceRatio;
    const startX = imageRect.left + (imageRect.width - sourceWidth) / 2;
    const startY = imageRect.top + (imageRect.height - sourceHeight) / 2;
    const targetX = cartRect.left + cartRect.width / 2;
    const targetY = cartRect.top + cartRect.height / 2;
    const deltaX = targetX - (startX + sourceWidth / 2);
    const deltaY = targetY - (startY + sourceHeight / 2);
    const targetSize = 30;

    window.reselluneFlyToCartActive = true;
    const clone = image.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('id');
    Object.assign(clone.style, {
      position: 'fixed',
      left: `${startX}px`,
      top: `${startY}px`,
      width: `${sourceWidth}px`,
      height: `${sourceHeight}px`,
      objectFit: 'contain',
      borderRadius: '1.2rem',
      pointerEvents: 'none',
      zIndex: '10000',
      margin: '0',
      opacity: '1',
      transformOrigin: 'center center'
    });
    document.body.appendChild(clone);

    const animation = clone.animate(
      [
        { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1, offset: 0 },
        { transform: `translate3d(${deltaX * .72}px, ${deltaY * .72}px, 0) scale(.58)`, opacity: .96, offset: .68 },
        { transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${targetSize / sourceWidth})`, opacity: .08, offset: 1 }
      ],
      { duration: 760, easing: 'cubic-bezier(.22, .8, .24, 1)', fill: 'forwards' }
    );

    return new Promise((resolve) => {
      const cleanup = () => {
        clone.remove();
        window.reselluneFlyToCartActive = false;
        pulseCartIcon();
        resolve();
      };
      animation.finished.then(cleanup).catch(cleanup);
    });
  };

  window.ReselluneFlyToCart = flyToCart;
})();
